import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID, idProceso, codActividad, asunto, contenido, eventoPadre = '', codTipAct = '00',colaboradores) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    asunto,
    coUsuarioDest: '',
    codTipAct:'06',
    contenido:contenido.replace(/\n/g, "<br />"),
    dirCorreo: '',
    indEnvioCorreo: '',
    numCorrelativoPadre: eventoPadre,
    numRegiRela: '',
    tipoEvento: '',
    tipoRegiRela: '',
    listadirCorreo:colaboradores,
    idProceso: idProceso
  };

  return customAxios.post(`${FDV_URL}/ficha-venta/fichas-venta/add-activity/${fdvID}/${codActividad}/eventos`, data, config);
}


// WEBPACK FOOTER //
// ./src/utils/addActivity.js